import React from 'react'
import { Link } from "react-router-dom";

const Footer = ({colorClass,clas}) => {

    // console.log(color);
  return (
    <footer className={`${colorClass} text-[10px] lg:text-xs flex justify-center font-museob w-full mb-2 `} >
    <span className='pr-2 '>&#169;Dreamstars 2022</span>
    <Link to="/terms" className={`px-2  ${clas}  ${colorClass} hover:no-underline`} >Terms of Services </Link>
    <Link to="/privacy-policy" className={`pl-2  ${colorClass} hover:no-underline`}>Privacy Policy </Link>
  </footer>
  )
}

export default Footer
